<template>
  <svg width="28" height="28" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12.9199" cy="12.6644" r="12" fill="#F9F9F9"/>
<path d="M8.8267 17.8135C8.8267 18.5469 9.44066 19.1469 10.191 19.1469H15.6484C16.3988 19.1469 17.0127 18.5469 17.0127 17.8135V9.81352H8.8267V17.8135ZM17.6949 7.81352H15.3073L14.6252 7.14685H11.2143L10.5321 7.81352H8.14453V9.14685H17.6949V7.81352Z" fill="#B8CDD7"/>
</svg>

</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
svg {
    circle, path {
        transition: all 0.2s ease;
    }
    &:hover {
        circle {
            fill: #B8CDD7;
        }
        path {
            fill: #F9F9F9;
        }
    }
}
</style>